import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IConsultPrepaidApplicationDataTableRowFormMeta {
  appDateTable: FormInputMeta,
  appIDTable: FormInputMeta,
  clientTable: FormInputMeta,
  deciDateTable: FormInputMeta,
  prepaidProgTable: FormInputMeta,
  cardProgTable: FormInputMeta,
  statusTable: FormInputMeta,
  schema: any,
}

const ConsultPrepaidApplicationDataTableRowFormMeta = {} as IConsultPrepaidApplicationDataTableRowFormMeta;

 
ConsultPrepaidApplicationDataTableRowFormMeta.appDateTable = {
  name: "appDateTable",
  label: "App. Date",
  type: "date",
  validation: yup.string().required(),
}
ConsultPrepaidApplicationDataTableRowFormMeta.appIDTable = {
  name: "appIDTable",
  label: "App. ID",
  type: "text",
  validation: yup.string().required(),
}
ConsultPrepaidApplicationDataTableRowFormMeta.clientTable = {
  name: "clientTable",
  label: "Client",
  type: "text",
  validation: yup.string().required(),
}
ConsultPrepaidApplicationDataTableRowFormMeta.deciDateTable = {
  name: "deciDateTable",
  label: "Deci. Date",
  type: "date",
  validation: yup.string().required(),
}
ConsultPrepaidApplicationDataTableRowFormMeta.prepaidProgTable = {
  name: "prepaidProgTable",
  label: "Prog. prépayé",
  type: "text",
  validation: yup.string().required(),
}
ConsultPrepaidApplicationDataTableRowFormMeta.cardProgTable = {
  name: "cardProgTable",
  label: "Prog. carte",
  type: "text",
  validation: yup.string().required(),
}
ConsultPrepaidApplicationDataTableRowFormMeta.statusTable = {
  name: "statusTable",
  label: "Statut",
  type: "text",
  validation: yup.string().required(),
}

ConsultPrepaidApplicationDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(ConsultPrepaidApplicationDataTableRowFormMeta));

export default ConsultPrepaidApplicationDataTableRowFormMeta;